import { render, staticRenderFns } from "./insCourse.vue?vue&type=template&id=23941d92&"
import script from "./insCourse.vue?vue&type=script&lang=js&"
export * from "./insCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports